import { Pill } from '@crab/coral';

export type ViewMode = 'aggregated' | 'table-flow' | 'history';

interface Props {
  mode: ViewMode;
  onChange: (mode: ViewMode) => void;
  labels?: { aggregated?: string; tableFlow?: string; history?: string };
}

export function ViewSwitcher({ mode, onChange, labels }: Props) {
  const tabs: { key: ViewMode; label: string }[] = [
    { key: 'aggregated', label: labels?.aggregated ?? '按菜品' },
    { key: 'table-flow', label: labels?.tableFlow ?? '按桌号' },
    { key: 'history', label: labels?.history ?? '历史' },
  ];

  return (
    <div className="flex shrink-0 rounded-xl bg-surface-muted p-0.5" role="tablist">
      {tabs.map((tab) => (
        <Pill
          key={tab.key}
          variant="neutral"
          selected={mode === tab.key}
          onClick={() => onChange(tab.key)}
          role="tab"
          aria-selected={mode === tab.key}
          className="min-h-[var(--size-touch-rec)] rounded-lg text-xs font-bold sm:text-sm"
        >
          {tab.label}
        </Pill>
      ))}
    </div>
  );
}
